<app-account-header [userNamechangeData]="userNamechangeval"></app-account-header>
<div class="boxstyle">
<div class="container">
    <div class="clear30"></div>
    <div>
        <button type="button" class="semi-bold fs-16 olnone getReliablebtn" (click)="toggleadd()">Go To GetReliable</button>   
    </div>  
    <div id="addpopup" *ngIf="drop" class="addlabelbox">
        <label class="fs-16 semi-bold cp m-0 olnone" (click)="toggleadd()">Agent Code TL9087A</label>
        <div class="clear10"></div>
        <label class="fs-16 semi-bold cp olnone" (click)="toggleadd()">Agent Code TL9087A</label>
    </div>
    <div class="clear30"></div>
    <div>
    <button type="button" class="semi-bold fs-16 olnone accountbtn"routerLink="/account-info" >Your Account</button> 
    </div>
</div>
</div>